import {ApUploadComponent}                                 from './components/ap-upload.component';
import {ApImportOverviewComponent}                         from './components/overview/ap-import-overview.component';
import {ApUploadFormatsComponent}                          from './components/ap-upload-formats.component';
import {FormsModule, ReactiveFormsModule}                  from '@angular/forms';
import {ApCoreModule}                                      from '../ap-core/ap-core.module';
import {ApIconModule}                                      from '../icons/ap-icon.module';
import {LayoutModule}                                      from '@progress/kendo-angular-layout';
import {ButtonModule, SplitButtonModule}                   from '@progress/kendo-angular-buttons';
import {CommonModule}                                      from '@angular/common';
import {InputsModule}                                      from '@progress/kendo-angular-inputs';
import {ComboBoxModule, DropDownsModule}                   from '@progress/kendo-angular-dropdowns';
import {NgModule}                                          from '@angular/core';
import {DateInputsModule}                                  from '@progress/kendo-angular-dateinputs';
import {ApImportRoutes}                                    from './ap-import.routes';
import {ApTranslationModule}                                             from '../translation/ap-translation.module';
import {BodyModule, GridModule, HeaderModule, PagerModule, SharedModule} from '@progress/kendo-angular-grid';
import {UploadModule, UploadService}                                     from '@progress/kendo-angular-upload';
import {HTTP_INTERCEPTORS, HttpClientModule}               from '@angular/common/http';
import {ApUploadInterceptorService}                        from './services/ap-upload-interceptor.service';
import {ApTooltipModule}                                   from '../ap-tooltip/ap-tooltip.module';
import {ApResponsiveTextModule}                            from '../ap-responsive-text/ap-responsive-text.module';
import {ApSectionHeaderModule}                             from '../ap-section-header/ap-section-header.module';
import {ApDynComponentModule}                              from '../ap-dyncomponent/ap-dyncomponent.module';
import {ApUtilsModule}                                     from '../ap-utils';
import {ApPermissionModule}                                from '../ap-permission/ap-permission.module';
import {
  ApLabResultFilesOverviewComponent
}                                                          from './components/overview/ap-lab-result-files-overview.component';
import {
  ApLogfileFilesOverviewComponent
}                                                          from './components/overview/ap-logfile-files-overview.component';

@NgModule({
  declarations: [
    ApUploadComponent,
    ApImportOverviewComponent,
    ApUploadFormatsComponent,
    ApLabResultFilesOverviewComponent,
    ApLogfileFilesOverviewComponent
  ],
  exports: [
    ApUploadComponent,
    ApImportOverviewComponent,
    ApUploadFormatsComponent,
  ],
  imports: [
    ReactiveFormsModule,
    HttpClientModule,
    ApCoreModule,
    ApIconModule,
    LayoutModule,
    ButtonModule,
    CommonModule,
    SplitButtonModule,
    InputsModule,
    ComboBoxModule,
    DateInputsModule,
    DropDownsModule,
    FormsModule,
    GridModule,
    ApTranslationModule,
    ApImportRoutes,
    UploadModule,
    SharedModule,
    BodyModule,
    HeaderModule,
    ApTooltipModule,
    ApResponsiveTextModule,
    PagerModule,
    ApSectionHeaderModule,
    ApDynComponentModule,
    ApUtilsModule,
    ApPermissionModule
  ],
  providers: [
    UploadService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApUploadInterceptorService,
      multi: true
    }]
})
export class ApImportModule {
}
